import { useEffect, useState } from 'react';
import { api } from './api.js';

// Categories rarely change: fetched once per page load and shared.
// refreshCategories() reloads them (e.g. after publishing sectors created
// new department categories).
let categoriesPromise = null;
const listeners = new Set();
export function refreshCategories() {
  categoriesPromise = api('/categories').catch((e) => { categoriesPromise = null; throw e; });
  categoriesPromise.then((c) => listeners.forEach((fn) => fn(c))).catch(() => {});
}
// Changed in Admin › Catégories: every screen showing the tree gets the new one.
if (typeof window !== 'undefined') {
  window.addEventListener('pme:live', (e) => {
    if (e.detail?.type !== 'content' || e.detail.payload?.area !== 'catalogue') return;
    categoriesPromise = api('/categories').catch((err) => { categoriesPromise = null; throw err; });
    categoriesPromise.then((c) => { for (const fn of listeners) fn(c); }).catch(() => {});
  });
}
export function useCategories() {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    categoriesPromise ||= api('/categories').catch((e) => { categoriesPromise = null; throw e; });
    let alive = true;
    const fn = (c) => { if (alive) setCategories(c); };
    listeners.add(fn);
    categoriesPromise.then(fn).catch(() => {});
    return () => { alive = false; listeners.delete(fn); };
  }, []);
  return categories;
}
